import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"
import _imports_0 from '@/assets/images/imac.png'


const _hoisted_1 = {
  id: "about-section",
  class: "about-section"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", null, "О ПРОЕКТЕ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", null, "Что может наш сервис ?", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "Project Screenshot",
  class: "project-image"
}, null, -1)
const _hoisted_6 = { class: "features" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _hoisted_4,
      _hoisted_5,
      _createElementVNode("div", _hoisted_6, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.features, (feature, index) => {
          return (_openBlock(), _createElementBlock("div", {
            key: index,
            class: "feature"
          }, [
            _createElementVNode("h4", null, _toDisplayString(feature.title), 1),
            _createElementVNode("p", null, _toDisplayString(feature.description), 1)
          ]))
        }), 128))
      ])
    ])
  ]))
}